<template>
  <v-ons-alert-dialog
    :title="title"
    :visible.sync="innerShow"
    :footer="footerLinks"
    :cancelable="true"
    @update:visible="updateVisible"
    :class="[
      {
        '--centered': centered,
        '--no-title': !title,
        '--vertical-actions': verticalActions
      }
    ]"
  >
    <slot></slot>
  </v-ons-alert-dialog>
</template>

<script>
export default {
  props: {
    title: { type: String },
    show: { type: Boolean, default: true },
    actions: { type: Array, default: () => [] }, // [{ title: string, callback: () => void }]
    centered: { type: Boolean, default: true },
    verticalActions: { type: Boolean, default: false }
  },

  data() {
    return {
      innerShow: false
    }
  },

  computed: {
    footerLinks() {
      return this.actions.reduce((acc, action) => {
        acc[action.title] = action.callback
        return acc
      }, {})
    }
  },

  methods: {
    updateVisible(visible) {
      this.innerShow = visible

      visible ? this.$emit("open") : this.$emit("close")
    }
  },

  watch: {
    show: {
      immediate: true,
      handler: function(show) {
        this.innerShow = show
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/variables";

ons-alert-dialog {
  &.--centered {
    .alert-dialog-title.alert-dialog-title--material,
    .alert-dialog-content--material {
      text-align: center;
    }
  }

  &.--no-title {
    .alert-dialog-content.alert-dialog-content--material {
      margin-top: 0;
    }
  }

  &.--vertical-actions {
    .alert-dialog-footer--material {
      flex-direction: column;

      .alert-dialog-button--material {
        width: 100%;
      }
    }
  }
}

.alert-dialog--material {
  border-radius: var(--border-radius);
}

.alert-dialog-container--material {
  padding-top: $size--5;
  border-radius: var(--border-radius);
}

.alert-dialog-title.alert-dialog-title--material {
  font-weight: $font-weight--bold;
}

.alert-dialog-content--material {
  font-weight: $font-weight--semi-bold;
  margin: $size--4 0 $size--5;
}

.alert-dialog-footer--material {
  display: flex;
}

.alert-dialog-button--material {
  flex-grow: 1;
  height: 100%;
  margin: 0;
  text-transform: none;
  line-height: $size--9;
  border-top: 1px solid $color-ui--grey-20;
  color: $color-ui--grey-70;

  &:last-child {
    color: var(--brand-color-hex);
  }

  &:hover {
    cursor: pointer;
  }
}
</style>
